import { Space, Typography } from 'antd'

const DSNotificationDetails: React.FC = () => {
  return (
    <Space direction="vertical">
      <Typography.Text>
        Users associated with Disciplines always receive notifications for Route
        to Discipline Action
      </Typography.Text>
    </Space>
  )
}

export default DSNotificationDetails
